module.exports = __webpack_public_path__ + "img/MMR.586bcdf9.svg";